import styled from 'styled-components';
import { Grid, Paper, TextField, Typography } from '@material-ui/core';

export const Root = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoginBox = styled.div`
  width: 28vw;
  margin: 0 auto;
  .MuiTab-wrapper {
    font-weight: bold;
    text-transform: capitalize;
    font-size: 20px;
  }
  @media only screen and (max-width: 1366px) {
    width: 50vw;
  }
  @media only screen and (max-width: 768px) {
    width: 55vw;
  }
  @media only screen and (max-width: 480px) {
    width: 90vw;
  }
`;

export const StyledTab = styled(Paper)`
  .MuiTabs-indicator {
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
`;

export const FormArea = styled.div`
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 50px;
`;

export const Form = styled.form`
  display: grid;
  width: 100%;
`;

export const StyledInput = styled(TextField)`
  margin-bottom: ${({ marginbottom }) => (marginbottom ? marginbottom + 'px' : '24px')};
  width: 100%;
`;

export const AddDependent = styled(Grid)`
  align-items: center;
  display: flex;
  margin-top: -5px;
`;

export const AskDependent = styled(Grid)`
  align-items: center;
  display: flex;
  margin-top: -25px;
  .MuiFormControlLabel-root {
    margin-left: 20px;
  }
`;

export const ForgotPassword = styled.span`
  margin: 23px 0 30px;
  font-size: 16px;
  color: #e0e0e0;
  cursor: pointer;
  &:hover {
    transition: 0.5s;
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;

export const Logo = styled.div`
  display: flex;
  align-items: baseline;
  width: 100vw; 
  text-align: center;
  padding-bottom: 40px;
  justify-content: center;
  img {
    width: 20rem;
    @media only screen and (max-width: 800px) {
      width: 15rem;
    }
  }
`;

export const LoginArea = styled.div`
  display: grid;
  width: 100%;
`;

export const TitleIntranet = styled(Typography)`
  font-family: IBMPlexSans-SemiBold;
  padding-left: 16px;
  font-size:50px;
  color: ${({ theme }) => theme.palette.secondary.main};
  
 
  @media only screen and (min-width: 768px) {
    font-size:3rem;
  }
`;
